function contentHeight() {
  const siteSidebar = $('.site-inner .site-sidebar').innerHeight()
  const siteContent = $('.site-inner .block-content').innerHeight()

  if (siteSidebar > siteContent) {
    $('.site-inner .block-content').css('min-height', siteSidebar + 'px')
  }
}
function responsiveTables() {
  $('table')
    .addClass('table')
    .wrap("<div class='table-responsive'></div>")
}

function scroolToContent() {
  $(document).ready(function($) {
    if ($(window).width() < 768 && $('#site-content').length) {
      $('html, body').animate(
        {
          scrollTop: $('#site-content').offset().top
        },
        1000
      )
    }
  })
}

export { contentHeight, responsiveTables, scroolToContent }
